import script from "./TreeItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./TreeItem.vue?vue&type=script&setup=true&lang=ts"

import "./TreeItem.vue?vue&type=style&index=0&id=b556b2ba&scoped=true&lang=scss"

import exportComponent from "/builds/boikovky/pro2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b556b2ba"]])

export default __exports__
import QTree from 'quasar/src/components/tree/QTree.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpinnerIos from 'quasar/src/components/spinner/QSpinnerIos.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QSlideTransition from 'quasar/src/components/slide-transition/QSlideTransition.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTree,QIcon,QSpinnerIos,QChip,QSlideTransition});
